import { render, staticRenderFns } from "./VPhonesPopover.vue?vue&type=template&id=e1b4a5c2&"
import script from "./VPhonesPopover.vue?vue&type=script&lang=js&"
export * from "./VPhonesPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports